<template>
  <MsLoading v-if="isLoading" class="app-busy" fullscreen label="Working" >
    <MsLogo variant="mark" />
  </MsLoading>

</template>
<script lang="ts">

import { defineComponent } from 'vue'
import {mapState} from "pinia";
import {useGeneralStore} from "@shared/stores/general.store";
import {MsLoading, MsLogo} from '@shared/ms-components'

export default defineComponent({
  name: 'LoadingModalWidget',
  components: {MsLoading, MsLogo},
  computed: {
    ...mapState(useGeneralStore, ['isLoading'])
  }
})
</script>

<style lang="scss" scoped>
.app-busy {
  --loading-backdrop: var(--loading-veil);

  backdrop-filter: blur(var(--loading-veil-blur));
}
</style>
